<template>
  <div class="booking-list">
    <div class="booking-division" />

    <div class="booking-header-search">
      <form action="/">
        <van-search
          v-model="searchForm.value"
          placeholder="请输入二级机构/三级机构"
          @search="onSearch"
          show-action
        >
          <template #action>
            <div @click="onSearch(searchForm.value)">搜索</div>
          </template>
        </van-search>
      </form>
      <div
        class="booking-header-search-right"
        @click="goDetail({
          type: 'myself',
          status: ''
        
        })"
      >
        <van-icon
          name="newspaper-o"
          size="24px"
          color="blue"
        />
        <span>我的录入</span>
      </div>

    </div>
    <div class="booking-division" />
    <div class="booking-list-main">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div
          class="booking-list-item"
          v-for="item in orderList"
          :key="item.id"
        >
          <div class="booking-list-item-option">
            <div>
              <!-- {{ currentUserInfo.user_name }} -->
              {{ item.user_name }}
            </div>
            <div>
              {{ item.level }}
            </div>
          </div>
          <div class="booking-list-item-option">
            <div>
              开卡总金额：{{ item.total_amount }}
            </div>
            <div>
            </div>
          </div>
          <div class="booking-list-item-option">
            <div>
              实付金额（财务已核对）：{{ item.pay_amount_check }}
              <van-icon
                name="todo-list-o"
                size="24px"
                color="blue"
                @click="goDetail({
          type: 'detail',
          status: '1',
          item,
        })"
              />
            </div>
            <div>
            </div>
          </div>
          <div class="booking-list-item-option">
            <div>
              实付金额（待财务核对）：{{ item.pay_amount_check_wait }}
              <van-icon
                name="todo-list-o"
                size="24px"
                color="blue"
                @click="goDetail({
          type: 'detail',
          status: '0',
          item,

        })"
              />
            </div>
            <div>
            </div>
          </div>
          <div class="booking-list-item-option">
            <div>
              实付金额（财务核对失败）：{{ item.pay_amount_check_fail }}
              <van-icon
                name="todo-list-o"
                size="24px"
                color="blue"
                @click="goDetail({
          type: 'detail',
          status: '2',
          item,

        })"
              />
            </div>
            <div>
            </div>
          </div>

          <div class="booking-list-item-option">
            <div>
              待收金额：{{ item.unreceived_amount }}
            </div>
            <div>

            </div>
          </div>
          <div class="booking-list-item-option">
            <div>

            </div>
            <div class="booking-list-item-action">

              <span
                class="booking-label"
                @click="copy(item)"
              >
                上传回款
              </span>
            </div>
          </div>
          <div class="booking-division" />

        </div>
      </van-list>

    </div>
    <van-popup
      v-model="showUploadPopup"
      position="bottom"
    >
      <div class="booking-home-search">
        <div class="booking-home-search-header">
          <div @click="showUploadPopup = false">
            取消
          </div>
          <div
            class="booking-submit"
            @click="uploadConfirm"
          >
            确定
          </div>
        </div>
        <div class="booking-division" />

        <div class="booking-list-cancel">
          <van-form>

            <van-field
              name="checkboxGroup"
              label="支付方式"
            >
              <template #input>
                <van-radio-group
                  v-model="uploadForm.pay_type"
                  direction="horizontal"
                  @change="onPayTypeChange"
                >
                  <van-radio name="1">非对公转账</van-radio>
                  <van-radio name="2">对公转账</van-radio>
                </van-radio-group>
                <!-- <van-checkbox-group
                  v-model="uploadForm.pay_type"
                  direction="horizontal"
                >
                  <van-checkbox name="1">微信转账</van-checkbox>
                  <van-checkbox name="2">对公转账</van-checkbox>
                </van-checkbox-group> -->
              </template>
            </van-field>
            <!-- <van-field
              v-model="uploadForm.received_amount"
              type="number"
              label="实付金额"
            /> -->
            <van-field
              readonly
              clickable
              label="产品类型"
              :value="uploadForm.product_type_name"
              placeholder="选择产品类型"
              @click="showProductTypePicker = true"
            />
            <van-popup
              v-model="showProductTypePicker"
              round
              get-container="body"
              position="bottom"
            >
              <van-picker
                show-toolbar
                :columns="productTypeColumns"
                @cancel="showProductTypePicker = false"
                @confirm="onProductTypeConfirm"
              />
            </van-popup>
            <van-field
              v-model="uploadForm.remark"
              rows="3"
              autosize
              label="备注"
              type="textarea"
              placeholder="请输入备注"
            />
            <div class="booking-paymentReceipt">
              <paymentReceipt
                ref="paymentReceipt"
                @answerChange="answerChange"
                :payMethod="uploadForm.pay_type == 1 ? 'weixin' : 'duigong'"
              />

            </div>

          </van-form>
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="dupPrompt"
      style="width: 80%;"
    >
      <div class="dupPrompt">
        <h3>
          请确认你的付款凭证
        </h3>
        <div class="dupPrompt-content">
          <p>
            <span
              v-for="(i,index) in fileList"
              :key="index"
            >{{i.message}}</span>，
          </p>
          请更换凭证。
        </div>
        <el-button
          type="danger"
          round
          @click="dupPrompt = false"
        >确认</el-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import bookingService from "@/apis/booking";
import getUserInfo from "@/models/userInfo";
import moment from "moment";
import { Toast } from "vant";
import enums from "@/views/booking/mixins/enums";
import paymentReceipt from "@/views/form/components/paymentReceipt";

export default {
  components: {
    paymentReceipt,
  },
  data() {
    return {
      dupPrompt: false,
      orderList: [],
      searchForm: {},
      currentUserInfo: {},
      showUploadPopup: false,
      showProductTypePicker: false,
      productTypeColumns: [],
      uploadForm: {
        pay_type: [],
      },
      fileList: [],
      currentOrder: {},
      pageInfo: {
        page_index: 0,
        page_size: 50,
        total: 50,
      },
      loading: false,
      finished: false,
      uploadIng: false,
    };
  },
  mixins: [enums],

  async created() {
    const userInfo = await getUserInfo();
    this.currentUserInfo = userInfo;
    this.getDingdingDic();
  },
  methods: {
    moment,
    answerChange(fileList) {
      this.fileList = fileList.answer;
    },
    onProductTypeConfirm(value) {
      this.uploadForm.product_type_name = value.text;
      this.uploadForm.product_type = value.value;
      this.showProductTypePicker = false;
    },
    payTypeChange(value) {
      console.log(value);
      this.uploadForm.pay_type = value;
    },
    onLoad() {
      this.pageInfo.page_index += 1;
      this.getOrderList();
    },
    uploadConfirm() {
      if (this.uploadIng) return;
      const { uploadForm, fileList, currentUserInfo } = this;
      let errMsg = "";
      if (!uploadForm.pay_type || uploadForm.pay_type.length === 0) {
        errMsg = "请选择支付方式";
      } else if (!uploadForm.product_type) {
        errMsg = "请选择产品类型";
      } else if (!this.fileList.length) {
        errMsg = "请上传付款凭证";
      } else if (fileList.some((item) => item.status === "uploading")) {
        // 有文件在上传中等上传结束才能提交
        errMsg = "文件正在上传中，请稍后";
      }
      if (errMsg) {
        Toast(errMsg);
        return;
      }
      // if (fileList.some((item) => item.message)) {
      //   this.dupPrompt = true;
      //   return;
      // }
      const params = {
        ...uploadForm,
        pay_type: uploadForm.pay_type,
        Files: fileList,
        ding_id: currentUserInfo.ding_user_id,
      };
      this.uploadIng = true;
      bookingService
        .returnedMoneyEdit(params)
        .then((res) => {
          console.log(res);
          this.uploadIng = false;

          if (res?.Status && res.Status !== 200) {
            Toast(res.Message);
          } else {
            Toast("上传成功");
            this.pageInfo.page_index = 1;
            this.getOrderList();
            this.showUploadPopup = false;
          }
        })
        .catch(() => {
          this.uploadIng = false;
        });
    },
    getDingdingDic() {
      bookingService.getDingdingDic().then((res) => {
        const data = res.productType;
        data.forEach((item) => {
          item.text = item.v;
          item.value = item.k;
        });
        this.productTypeColumns = data;
      });
    },
    copy(item) {
      this.uploadForm = {};
      this.fileList = [];
      const { uploadForm } = this;
      this.currentOrder = item;
      uploadForm.id = item.id;
      delete uploadForm.pay_type;
      this.showUploadPopup = true;
    },
    onSearch(query) {
      this.pageInfo.page_index = 1;
      this.getOrderList(query);
    },
    getOrderList(query = "") {
      const { currentUserInfo, pageInfo, searchForm } = this;
      const params = {
        keywork: query || searchForm.value,
        user_ding_id: currentUserInfo.ding_user_id,
        page_index: pageInfo.page_index,
        page_size: pageInfo.page_size,
      };
      this.loading = true;
      bookingService.returnedMoneyList(params).then((res) => {
        pageInfo.total = res.total_record_count;
        if (res.page_index * res.page_size >= res.total_record_count) {
          this.finished = true;
        }
        res.data.forEach((item) => {
          // level1、level2、level3、level4有值的拼接成字符串，-隔开
          item.level = [item.level1, item.level2, item.level3, item.level4]
            .filter(Boolean)
            .join("-");
        });
        if (pageInfo.page_index == 1) {
          this.orderList = res.data;
        } else {
          this.orderList.push(...res.data);
        }
        this.loading = false;
      });
    },

    goDetail({ type, status = "", item = {} }) {
      this.$router.push({
        name: "BookingRefundDetail",
        query: {
          type,
          status,
          id: item.id,
        },
      });
    },
    onPayTypeChange() {
      this.$refs.paymentReceipt.reset();
    },
  },
};
</script>

<style lang="scss" scoped>
.booking-header-search {
  display: flex;
  justify-content: space-between;
  align-items: center;
  form {
    flex: 1;
  }
  .booking-header-search-right {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 12px;
  }
}
.booking-list-item {
  .booking-list-item-option {
    display: flex;
    justify-content: space-between;
    padding: 15px 20px;
    border-bottom: 1px solid rgba(0, 48, 87, 0.1);
    & > div:nth-child(2) {
    }
  }
  .booking-list-item-action {
    display: flex;

    span {
      margin-left: 15px;
    }
  }
}
.booking-label {
  cursor: pointer;
}

.booking-paymentReceipt {
  padding: 10px 20px;
}
.dupPrompt {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
  .dupPrompt-content {
    text-align: center;
    margin: 20px 0;
    font-size: 12px;
    p {
      color: #f56c6c;
      margin: 0;
    }
  }
  .el-button {
    width: 200px;
  }
}
</style>
<style lang="scss">
</style>